function getCompetitionForm() {
    return document.getElementById('filmflix-plus-competition-form');
}

function createRowFromTemplate(templateId, containerId, index) {
    const template = document.getElementById(templateId);
    const container = document.getElementById(containerId);

    if (!template || !container) {
        return null;
    }

    const fragment = template.content.cloneNode(true);
    const row = fragment.firstElementChild;

    row.querySelectorAll('[data-name]').forEach(function (field) {
        field.name = field.dataset.name.replace('__INDEX__', index);
        field.removeAttribute('data-name');
    });

    container.appendChild(row);

    return row;
}

function nextRowIndex(container, rowSelector) {
    if (!container) {
        return 0;
    }

    let maximum = -1;

    container.querySelectorAll(rowSelector).forEach(function (row) {
        row.querySelectorAll('[name]').forEach(function (field) {
            const match = field.name.match(/\[(\d+)\]/);

            if (match) {
                maximum = Math.max(maximum, Number(match[1]));
            }
        });
    });

    return maximum + 1;
}

function renumberCompetitionHeadings() {
    document.querySelectorAll('[data-competition-hint-row]').forEach(function (row, index) {
        const heading = row.querySelector('[data-hint-heading]');

        if (heading) {
            const base = heading.textContent.replace(/\s+\d+$/, '').trim();
            heading.textContent = base + ' ' + (index + 1);
        }
    });

    document.querySelectorAll('[data-competition-prize-row]').forEach(function (row, index) {
        const heading = row.querySelector('[data-prize-heading]');

        if (heading) {
            const base = heading.textContent.replace(/\s+\d+$/, '').trim();
            heading.textContent = base + ' ' + (index + 1);
        }
    });
}

function formatCompetitionDate(value, fallback) {
    if (!value) {
        return fallback;
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
        return fallback;
    }

    return new Intl.DateTimeFormat(undefined, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    }).format(date);
}

function updateCompetitionHintsPreview(form) {
    const target = document.getElementById('filmflix-plus-competition-preview-hints');

    if (!target) {
        return;
    }

    const texts = [];

    form.querySelectorAll('[data-competition-hint-row]').forEach(function (row) {
        const field = row.querySelector('textarea[name*="[text]"]');

        if (field && field.value.trim()) {
            texts.push(field.value.trim());
        }
    });

    target.innerHTML = '';

    if (!texts.length) {
        const empty = document.createElement('span');
        empty.className = 'text-muted';
        empty.textContent = target.dataset.placeholder || '';
        target.appendChild(empty);
        return;
    }

    const list = document.createElement('ol');
    list.className = 'mb-0 ps-3';

    texts.forEach(function (text) {
        const item = document.createElement('li');
        item.textContent = text;
        list.appendChild(item);
    });

    target.appendChild(list);
}

function updateCompetitionPrizesPreview(form) {
    const target = document.getElementById('filmflix-plus-competition-preview-prizes');

    if (!target) {
        return;
    }

    const prizes = [];

    form.querySelectorAll('[data-competition-prize-row]').forEach(function (row) {
        const position = row.querySelector('input[name*="[position]"]');
        const title = row.querySelector('input[name*="[title]"]');

        if (title && title.value.trim()) {
            prizes.push({
                position: position ? position.value : '',
                title: title.value.trim()
            });
        }
    });

    target.innerHTML = '';

    if (!prizes.length) {
        const empty = document.createElement('span');
        empty.className = 'text-muted';
        empty.textContent = target.dataset.placeholder || '';
        target.appendChild(empty);
        return;
    }

    prizes.sort(function (a, b) {
        return Number(a.position || 0) - Number(b.position || 0);
    });

    const list = document.createElement('ol');
    list.className = 'mb-0 ps-3';

    prizes.forEach(function (prize) {
        const item = document.createElement('li');
        item.textContent = prize.title;
        list.appendChild(item);
    });

    target.appendChild(list);
}

function updateCompetitionPreview() {
    const form = getCompetitionForm();

    if (!form) {
        return;
    }

    const title = form.querySelector('[name="title"]');
    const description = form.querySelector('[name="description"]');
    const question = form.querySelector('[name="question"]');
    const endsAt = form.querySelector('[name="ends_at"]');

    const previewTitle = document.getElementById('filmflix-plus-competition-preview-title');
    const previewDescription = document.getElementById('filmflix-plus-competition-preview-description');
    const previewQuestion = document.getElementById('filmflix-plus-competition-preview-question');
    const previewEnd = document.getElementById('filmflix-plus-competition-preview-end');

    if (title && previewTitle) {
        previewTitle.textContent = title.value.trim() || previewTitle.dataset.placeholder;
    }

    if (description && previewDescription) {
        previewDescription.textContent = description.value.trim() || previewDescription.dataset.placeholder;
    }

    if (question && previewQuestion) {
        previewQuestion.textContent = question.value.trim() || previewQuestion.dataset.placeholder;
    }

    if (endsAt && previewEnd) {
        previewEnd.textContent = formatCompetitionDate(endsAt.value, previewEnd.dataset.placeholder);
    }

    updateCompetitionHintsPreview(form);
    updateCompetitionPrizesPreview(form);
}

function updateCompetitionImagePreview(file) {
    const image = document.getElementById('filmflix-plus-competition-preview-image');
    const wrapper = document.getElementById('filmflix-plus-competition-preview-image-wrapper');

    if (!file || !image || !wrapper) {
        return;
    }

    const reader = new FileReader();

    reader.onload = function (event) {
        image.src = event.target.result;
        wrapper.classList.remove('d-none');
    };

    reader.readAsDataURL(file);
}

document.addEventListener('click', function (event) {
    const form = getCompetitionForm();

    if (!form || !form.contains(event.target)) {
        return;
    }

    const addHint = event.target.closest('[data-competition-add-hint]');

    if (addHint) {
        const container = document.getElementById('filmflix-plus-hints');
        const index = nextRowIndex(container, '[data-competition-hint-row]');
        const row = createRowFromTemplate('filmflix-plus-hint-template', 'filmflix-plus-hints', index);

        if (row) {
            const order = row.querySelector('input[name*="[sort_order]"]');
            if (order) {
                order.value = container.querySelectorAll('[data-competition-hint-row]').length - 1;
            }
        }

        renumberCompetitionHeadings();
        updateCompetitionPreview();
        return;
    }

    const addPrize = event.target.closest('[data-competition-add-prize]');

    if (addPrize) {
        const container = document.getElementById('filmflix-plus-prizes');
        const index = nextRowIndex(container, '[data-competition-prize-row]');
        const row = createRowFromTemplate('filmflix-plus-prize-template', 'filmflix-plus-prizes', index);

        if (row) {
            const position = row.querySelector('input[name*="[position]"]');
            if (position) {
                position.value = container.querySelectorAll('[data-competition-prize-row]').length;
            }
        }

        renumberCompetitionHeadings();
        updateCompetitionPreview();
        return;
    }

    const remove = event.target.closest('[data-competition-remove-row]');

    if (remove) {
        const row = remove.closest('[data-competition-hint-row], [data-competition-prize-row]');
        if (row) {
            row.remove();
            renumberCompetitionHeadings();
            updateCompetitionPreview();
        }
    }
});

document.addEventListener('input', function (event) {
    const form = getCompetitionForm();
    if (form && form.contains(event.target)) {
        updateCompetitionPreview();
    }
});

document.addEventListener('change', function (event) {
    const form = getCompetitionForm();

    if (!form || !form.contains(event.target)) {
        return;
    }

    if (event.target.matches('[name="image"]')) {
        const file = event.target.files && event.target.files[0];
        if (file) {
            updateCompetitionImagePreview(file);
        }
    }

    updateCompetitionPreview();
});

window.addEventListener('load', function () {
    renumberCompetitionHeadings();
    updateCompetitionPreview();
});

window.addEventListener('pageshow', function () {
    renumberCompetitionHeadings();
    updateCompetitionPreview();
});

document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.matches('form[data-confirm]')) {
        return;
    }

    if (!window.confirm(form.dataset.confirm)) {
        event.preventDefault();
    }
});
